import { render, staticRenderFns } from "./Sidemenu.vue?vue&type=template&id=360eba72&"
import script from "./Sidemenu.vue?vue&type=script&lang=js&"
export * from "./Sidemenu.vue?vue&type=script&lang=js&"
import style0 from "./Sidemenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports